import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["progressBar"];

  connect() {
    console.log("Quick booking controller connected");
  }

  updateProgress(percentage) {
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${percentage}%`;
    }
  }
}
